var map = {
	"./courses1.svg": 368,
	"./courses10.svg": 369,
	"./courses2.svg": 370,
	"./courses3.svg": 371,
	"./courses4.svg": 372,
	"./courses5.svg": 373,
	"./courses6.svg": 374,
	"./courses7.svg": 375,
	"./courses8.svg": 376,
	"./courses9.svg": 236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 102;